import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const SealList = {
  namespaced: true,
  state: {
    campaigns_lists: [],
    current: null
  },
  getters: {
    campaigns_lists: state => state.campaigns_lists,
    detailSeal: state => state.current
  },
  mutations: {
    UPDATE_SEALLIST(state, payload) {
      state.campaigns_lists = payload['campaigns']
    },
    UPDATE_CURRENT_SEAL (state, payload) {
      state.current = payload
    }
  },
  actions: {
    /**
     * 過去キャンペーンのデータの選択
     * @param {Object} commit
     * @param {String} id
     */
    action_SelectDetailSeal ({ commit }, id) {
      console.log(this.state)
      console.log(this.state.SealList.campaigns_lists)
      const array = this.state.SealList.campaigns_lists.filter(data => data.id === id)
      console.log(array)
      console.log(array.length)
      if (array.length !== 1 || !array) throw new Error('指定されたキャンペーンが見つかりませんでした')
      if (window.localStorage) {
        window.localStorage.setItem('seal-detail', JSON.stringify(array[0]))
      }
      commit('UPDATE_CURRENT_SEAL', array[0])
    },
    /**
     * 過去のキャンペーン情報 シールのリストの取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchSealList({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getSealList(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        console.log('campaigns_list', res.data.data)
        commit('UPDATE_SEALLIST', res.data.data)
        localStorage.setItem('isKakoList', '0')
        if (this.state.SealList.campaigns_lists.length > 0) {
          localStorage.setItem('isKakoList', '1')
        }
      }
       else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
